<layout-block-list-outlet [list]="footerContent"
                          *ngIf="!blockedPages.includes(pageAlias$|async)"></layout-block-list-outlet>

<div>
    @for (link of menu?.footerMenu; track $index) {
        <a [routerLink]="link?.link" [target]="link?.target">{{ link?.title }}</a>
    }
</div>
